import axios from '../../utilities/axios';
import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
import config from '../../config.json';

import { submitToken, submitTokenCompleted, submitTokenFailed } from './tokenSlice';

export const validateTokenEpic = (action$) =>
	action$.pipe(
		ofType(submitToken),
		mergeMap(async (action) => {
			const response = await axios.post(
				`${config[process.env.REACT_APP_STAGE].api}/authentication`,
				action.payload
			);

			return response.data;
		}),
		switchMap((res) => [submitTokenCompleted(res)]),
		catchError((error, source) => merge(of(submitTokenFailed(error)), source))
	);

export default [validateTokenEpic];
